import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasNominaDispersionPagosOtrosListaComponent {
  idProyecto
  idNomina
  idTipoPago
  idMetodoPago
  idMoneda
  metodoPago
  total
  moneda
  onChange
  onClose
  actualizando = false
  resultados = []
  seleccionados = []
  filtro = ''
  promise = null

  constructor ($filter, NominasNominaDispersionPagosOtros) {
    this.NominasNominaDispersionPagosOtros = NominasNominaDispersionPagosOtros
    this.filterBy = $filter('filter')
  }

  $onInit () {
    this.promise = this.NominasNominaDispersionPagosOtros.get(this.idProyecto, this.idNomina, this.idTipoPago, this.idMoneda, this.idMetodoPago)
      .then(({data}) => {
        this.data = orderBy(data, ['id_moneda', 'colaborador']).map((item) => ({...item, $$seleccionado: false}))
        this.total = this.data.reduce((total, item) => total + (item.importe / item.tipo_cambio), 0)
        this.filtrar()
      })
  }

  actualizar (data) {
    if (data) {
      data.forEach((item) => {
        let seleccionado = this.data.find((seleccionado) => {
          return seleccionado.id_empresa === item.id_empresa
            && seleccionado.id_empleado === item.id_empleado
            && seleccionado.indice === item.indice
        })

        if (seleccionado) {
          Object.assign(seleccionado, item)
        }
      })
    }

    this.filtrar()
    this.seleccionar()

    this.onChange({$event: {data: this.data}})
  }

  cerrar () {
    this.onClose()
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)

    this.totalizar()
  }

  seleccionar () {
    this.seleccionados = this.data.filter((item) => item.$$seleccionado)
  }

  seleccionarItem (item) {
    item.$$seleccionado = !item.$$seleccionado

    this.seleccionar()
    this.totalizar()
  }

  seleccionarItems (todos) {
    this.resultados.forEach((item) => (item.$$seleccionado = todos))

    this.seleccionar()
    this.totalizar()
  }

  totalizar () {
    this.todosSeleccionados = this.resultados.every((item) => item.$$seleccionado)
  }
}

module.component('nominasNominaDispersionPagosOtrosLista', {
  controller: NominasNominaDispersionPagosOtrosListaComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    idMetodoPago: '<',
    idMoneda: '<',
    metodoPago: '<',
    total: '<',
    moneda: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/otros/lista/component.js